import gql from "graphql-tag";

const DELETE_LEAD_TRAFFIC = gql`
  mutation deleteLeadTraffic($input: LeadTrafficDeleteInput!) {
    deleteLeadTraffic(input: $input) {
      message
      code
    }
  }
`;

export default DELETE_LEAD_TRAFFIC;
